import request from "@/utils/request";

const apiUrl = {
  historyType: "/api/common/stage/list",
  typeList: "/api/common/type/list",
  typeCount: "/api/common/type/tjList",
  recommend: "/api/entity/recommend/list",
  areaLevelSource: "/api/common/map/level1list",
  resultSource: "/api/entity/map/level2List",
  detail: "/api/entity/",
  docFacet: "/api/entity/facet/document",
  placeFacet: "/api/entity/facet/place",
  searchList: "/api/entity/listpage/",
  facetAll: '/api/entity/facet/all',
};

export function queryData(type, params) {
  return request({
    url: apiUrl[type],
    method: "get",
    params,
  });
}

export function queryDetail(id) {
  return request({
    url: apiUrl.detail + id,
    method: "get",
  });
}

export function searchList(pageSize, pageNo, params) {
  return request({
    url: `${apiUrl.searchList}${pageNo}/${pageSize}`,
    method: "get",
    params,
  });
}
